"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridInjectionKey = exports.defaultSpan = void 0;
const _utils_1 = require("../../_utils");
exports.defaultSpan = 1;
exports.gridInjectionKey = (0, _utils_1.createInjectionKey)('n-grid');
